import React from 'react';
import Icon from '../../../components/AppIcon';

const ConversionFunnel = ({ data }) => {
  const leads = data?.leads || [];
  const total = leads?.length || 0;

  const stages = [
    { label: 'Total Leads', count: total, icon: 'Users', color: 'bg-blue-500' },
    { label: 'Qualified', count: leads?.filter(l => (l?.lead_score || 0) >= 50)?.length, icon: 'Star', color: 'bg-purple-500' },
    { label: 'High Score', count: leads?.filter(l => (l?.lead_score || 0) >= 80)?.length, icon: 'TrendingUp', color: 'bg-orange-500' },
    { label: 'Converted', count: leads?.filter(l => l?.is_converted)?.length, icon: 'Trophy', color: 'bg-green-500' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-6">Conversion Funnel</h3>
      {total === 0 ? (
        <div className="text-center py-12">
          <Icon name="GitBranch" size={48} className="text-muted-foreground mx-auto mb-4 opacity-40" />
          <p className="text-muted-foreground">No leads data available for funnel analysis</p>
        </div>
      ) : (
        <div className="space-y-4">
          {stages?.map((stage, index) => {
            const pct = total > 0 ? Math.round((stage?.count / total) * 100) : 0;
            const width = Math.max(pct, 5);
            return (
              <div key={index} className="space-y-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-2">
                    <Icon name={stage?.icon} size={16} className="text-muted-foreground" />
                    <span className="text-sm font-medium text-foreground">{stage?.label}</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-sm font-bold text-foreground">{stage?.count?.toLocaleString()}</span>
                    <span className="text-xs text-muted-foreground">({pct}%)</span>
                  </div>
                </div>
                <div className="w-full bg-muted rounded-full h-3">
                  <div
                    className={`${stage?.color} h-full rounded-full transition-all duration-500`}
                    style={{ width: `${width}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ConversionFunnel;